import {
    fetchDeleteOnlineAccount,
    fetchPostOpenBankingReconsent,
    PostOpenBankingReconsentResponse
} from '@iwoca/lapi-client/edge';

type ExtendConnectionResult = PostOpenBankingReconsentResponse['data'];

export const extendConnection = async ({
    stateKey,
    onlineAccountId
}: {
    stateKey: string;
    onlineAccountId: string;
}): Promise<ExtendConnectionResult> => {
    if (!import.meta.env.VITE_BUILD_HASH) {
        throw new Error('Missing build hash');
    }

    const response = await fetchPostOpenBankingReconsent({
        stateKey,
        body: {
            data: {
                user_has_reconfirmed_consent: true,
                bundle_hash: import.meta.env.VITE_BUILD_HASH,
                online_account_id: onlineAccountId
            }
        }
    });

    return response.data;
};

export const revokeConnection = async ({
    stateKey,
    onlineAccountId
}: {
    stateKey: string;
    onlineAccountId: string;
}): Promise<void> => {
    await fetchDeleteOnlineAccount({ stateKey, onlineAccountId });
};
